var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgMainProgram = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 59,
    viewBox: "0 0 86 59",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56 59C54.9 59 53.9 58.6 53.1 57.8C51.6 56.2 51.6 53.7 53.2 52.1L76.2 30L53.2 7.89998C51.6 6.39998 51.6 3.79999 53.1 2.19999C54.6 0.599985 57.2 0.599985 58.8 2.09998L84.8 27.1C85.6 27.9 86 28.9 86 30C86 31.1 85.6 32.1 84.8 32.9L58.8 57.9C58 58.6 57 59 56 59ZM32.9 57.8C34.4 56.2 34.4 53.7 32.8 52.1L9.8 30L32.8 7.89998C34.4 6.39998 34.4 3.79999 32.9 2.19999C31.4 0.599985 28.8 0.599985 27.2 2.09998L1.2 27.1C0.4 27.9 0 28.9 0 30C0 31.1 0.4 32.1 1.2 32.9L27.2 57.9C28 58.6 29 59 30 59C31 59 32.1 58.6 32.9 57.8Z",
    fill: "#CDD4E4"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMainProgram, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/main-program.b4966d29.svg";
export { ForwardRef as ReactComponent };